module.exports = __webpack_public_path__ + "static/media/wrong.33018696.svg";